import { mdlServiceResponse } from "../models/service-models/common/ServiceResponse";
import { mdlCurrencyListRequest } from "../models/service-models/currency/CurrencyListRequest";
import { mdlCurrencyListResponse } from "../models/service-models/currency/CurrencyListResponse";
import { GetResponse } from "../utils/ApiClient";

module CurrencyService {
    export async function List(
        pRequest: mdlCurrencyListRequest
    ): Promise<mdlServiceResponse<mdlCurrencyListResponse>> {
        return await GetResponse<mdlServiceResponse<mdlCurrencyListResponse>>(
            "currency/list",
            pRequest
        );
    }
}
export { CurrencyService };
